import React from "react";
import Avatar from "boring-avatars";
import Link from "next/link";
import { FaUserCircle } from "react-icons/fa";
import { generateUserAvatarUrl } from "@utility/index";
import Image from "next/image";

export default function UserAvatar({ handleClick, user, active, size }) {
  const avatarUrl = generateUserAvatarUrl({ user });
  // User Avatar heights
  const userAvatarStyles = {
    small: "relative h-8 w-8",
    medium: "relative h-10 w-10",
    large: "relative h-16 w-16",
    xl: "relative h-18 w-18",
    xxl: "realtive h-24 w-24",
    xxxl: "relative h-40 w-40",
  };

  // Boring Avatar package heights
  const boringAvatarStyles = {
    small: 30,
    medium: 40,
    large: 65,
    xl: 70,
    xxl: 90,
    xxxl: 140,
  };

  if (active) {
    return !avatarUrl ? (
      <Link href={`/user/${user.username}`}>
        <div className="rounded-full cursor-pointer overflow-hidden">
          <Avatar
            size={boringAvatarStyles[size]}
            name={user.name}
            variant="beam"
            colors={["#D3643B", "#403B33", "#94C7B6", "#D6E1C7", "#EDEBE6"]}
            square={false}
          />
        </div>
      </Link>
    ) : (
      <div
        className={userAvatarStyles[size]}
        onClick={handleClick}
        aria-hidden="true"
      >
        <Image
          src={avatarUrl}
          width="100"
          height="100"
          className="rounded-full h-full w-full cursor-pointer object-cover"
          alt=""
        />
      </div>
    );
  }

  // If comment has been active/deleted.
  return (
    <div className="h-8 w-8">
      <FaUserCircle className="text-gray-300 h-full w-full object-cover" />
    </div>
  );
}
